import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "../features/counter/counterSlice";
import partnerTypeReducer from "../features/partner-types/partner-types-table-slice";
import partnerProfileReducer from "../features/partner/partner-profile-slice";
import agentProfileReducer from "../features/agent/edit-agent-slice";
import agentFilterReducer from "../features/agent/agent-filter-slice";
import searchBranchesReducer from "../features/branches/search-branches-slice";
import branchProfileReducer from "../features/branches/edit-branches-slice";
import addBranchReducer from "../features/branches/add-branch-slice";
import addPartnerReducer from "../features/partner/add-partner-slice";
import assignToBranchReducer from "../features/assign-to-branch/assign-to-branch-slice";
import assignToAgentsReducer from "../features/assign-to-agent/assign-to-agent-slice";
import assignToPartnerReducer from "../features/assign-to-partner/assign-to-partner-slice";
import lockersReducer from "../features/lockers/lockers-slice";
import lockerFeeTableReducer from "../features/locker-fees/locker-fee-table-slice";
import addUserFeeReducer from "../features/locker-fees/add-user-fees/add-user-fees-slice";
import addPartnerFeeReducer from "../features/locker-fees/add-partner-fees/add-partner-fees-slice";
import searchPartnerReducer from "../features/partner-table/partner-table-slice";
import lockerStorageFeesReducer from "../features/locker-storage-fees/locker-storage-fees-slice";
import paymentModeAndFeesReducer from "../features/payment-mode-and-fees/payment-mode-and-fees-slice";
import storageTimeLimitsReducer from "../features/storage-time-limits/storage-time-limits-slice";
import lockerTimeLimitsReducer from "../features/locker-time-limits/locker-time-limits-slice";
import lockerUserTypeReducer from "../features/locker-user-types/locker-user-types-slice";
import editPartnerFeeReducer from "../features/locker-fees/edit-partner-fees-slice";
import lockerUserAccountsReducer from "../features/locker-user-accounts/locker-user-accounts-slice";
import userProfileReducer from "../features/locker-user-accounts/user-profile-slice";
import peakHoursReportReducer from "../features/peak-hours-report/peak-hours-report-slice";
import accessPermissionReducer from "../features/access-permissions/index";
import packageDropoffPeakHoursReportReducer from "../features/package-dropoff-peak-hours/package-dropoff-peak-hours-report-slice";
import { packageDropoffPeakHoursReport } from "../features/package-dropoff-peak-hours/package-dropoff-peak-hours-report-slice";
export default configureStore({
  reducer: {
    counter: counterReducer,
    partnerTypesTable: partnerTypeReducer,
    partnerProfile: partnerProfileReducer,
    addPartner: addPartnerReducer,
    agentProfile: agentProfileReducer,
    agentFilter: agentFilterReducer,
    searchPartner: searchPartnerReducer,
    searchBranches: searchBranchesReducer,
    branchProfile: branchProfileReducer,
    addBranch: addBranchReducer,
    assignToBranch: assignToBranchReducer,
    assignToAgents: assignToAgentsReducer,
    assignToPartner: assignToPartnerReducer,
    lockers: lockersReducer,
    lockerFeeTable: lockerFeeTableReducer,
    addUserFee: addUserFeeReducer,
    addPartnerFee: addPartnerFeeReducer,
    editPartnerFee: editPartnerFeeReducer,
    lockerStorageFees: lockerStorageFeesReducer,
    paymentModeAndFees: paymentModeAndFeesReducer,
    storageTimeLimits: storageTimeLimitsReducer,
    lockerTimeLimits: lockerTimeLimitsReducer,
    lockerUserTypes: lockerUserTypeReducer,
    lockerUserAccounts: lockerUserAccountsReducer,
    userProfile: userProfileReducer,
    peakHoursReport: peakHoursReportReducer,
    packageDropoffPeakHoursReport: packageDropoffPeakHoursReportReducer,
    accessPermissions: accessPermissionReducer,
  },
});
